import React, { Component } from 'react'
import ReduxToastr from 'react-redux-toastr'
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/lib/withStyles'
import _get from 'lodash/get'
import { connect } from 'react-redux'
import { compose } from 'redux'
import history from '@source/history'
import config from '@source/config'

import { setRuntimeVariable } from '@actions/runtime'
import { showSuccessAlert } from '@actions/alert'

import AddEmailPhoneModal from "@components/AddEmailPhoneModal"
import CoronaPage from '@components/CoronaPage'
import SideHeader from '@components/SideHeader'
import Footer from '@components/Footer'

// external-global styles must be imported in your JS.
import normalizeCss from 'normalize.css'
import styles from './Layout.css'

let isMobile
class Layout extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  }

  state = {
    viewportWidth: 0,
    isLoading: true,
    isShowAddIdentityModal: false,
    identityModalType: ''
  }

  componentDidMount() {
    if (__BROWSER__) {
      this.setState({
        viewportWidth: window.innerWidth,
        isLoading: false,
      })
      const userAgent = navigator.userAgent
      const isIpad = /iPad/i.test(userAgent)
      const isMobileDevice = isIpad ? -1 : userAgent.toLowerCase().indexOf('mobile')
      isMobile = isMobileDevice > -1 || window.innerWidth <= 640
      this.props.updateIsMobile(isMobile)
      window.addEventListener('resize', this.handleWindowSizeChange)
      if (this.props.token) this.readIdentityModal()
    }
  }

  componentWillUnmount() {
    if (__BROWSER__) {
      window.removeEventListener('resize', this.handleWindowSizeChange)
    }
  }

  readIdentityModal = () => {
    const uriSearch = location.search
    const titleRegisterSuccess = _get(this.props.configParams, 'naming.accounts.register_success', 'Akun berhasil terdaftar')
    if (uriSearch) {
      const urlParams = new URLSearchParams(uriSearch)

      const identityModal = urlParams.get('identityModal')
      const identityModalType = urlParams.get('identityModalType')
      if (identityModal && identityModalType) {
        this.setState({
          isShowAddIdentityModal: identityModal == "1",
          identityModalType
        }, () => this.props.showSuccessAlert(titleRegisterSuccess))
      }
    }
  }

  handleOnVerification = data => {
    this.setState({ isShowAddIdentityModal: false })
    const titlePhone = _get(this.props.configParams, 'naming.emailphone.add_phone_title', 'Tambah Nomor Telepon')
    const titleEmail = _get(this.props.configParams, 'naming.emailphone.add_email_title', 'Tambah Email')
    const titlePhoneVerif = _get(this.props.configParams, 'naming.emailphone.otp_modal_title_phone', 'Verifikasi Nomor Telepon')
    if (this.state.identityModalType == 'phone') {
      if (isMobile) {
        history.push(`/accounts/add-emailphone?btp=${titlePhone}&act=Phone`)
        return
      }
      history.push({
        pathname: '/accounts/otpVerification',
        search: `btp=${titlePhoneVerif}&act=Phoneval&tab=Setting`,
        state: {
          isRegistered: true,
          isEmail: false,
          value: data.phone,
          password: '',
          addEmailPhoneComponent: true,
        },
      })
      return
    }
    history.push(`/accounts/add-emailphone?btp=${titleEmail}&act=Email`)
  }

  handleWindowSizeChange = () => {
    this.setState({
      viewportWidth: window.innerWidth,
    })
    const userAgent = navigator.userAgent
    const isIpad = /iPad/i.test(userAgent)
    const isMobileDevice = isIpad ? -1 : userAgent.toLowerCase().indexOf('mobile')
    isMobile = isMobileDevice > -1 || window.innerWidth <= 640
    this.props.updateIsMobile(isMobile)
  }

  render() {
    const {
      runtime: { noHeader: noHeaderRuntime },
      noHeader,
      noFooter,
      cleanLayout,
      configParams,
      showNotif,
      noHeaderLibrary,
      onBackButtonPress
    } = this.props
    const { viewportWidth, isLoading, identityModalType, isShowAddIdentityModal } = this.state

    let activeMenuId
    const menuRoutes = _get(configParams, 'routes', [])
    const isPhoneNumberEnabled = _get(configParams, 'data.is_phone_number_enabled', true)

    if (__BROWSER__) {
      const {
        runtime: { activeMenuId: activeMenuIdRuntime = 0 },
      } = this.props
      let hasActiveMenu = false
      menuRoutes.map(r => {
        const currentLoc = history.location.pathname + history.location.search

        if (r.path === '') {
          /** homepage */
          activeMenuId = 1
        } else if (currentLoc.includes(r.path) && r.menuId) {
          /** use default activeMenuId from configApp params */
          activeMenuId = r.menuId
          hasActiveMenu = true
        } else if (!hasActiveMenu) {
          /** config param doesn't have default activeMenuId then retrieve from apiCall */
          activeMenuId = activeMenuIdRuntime
        }
      })
    }

    return (
      <>
        {!isLoading && !noHeaderRuntime && !noHeader && (
          <SideHeader
            activeMenuId={activeMenuId}
            cleanLayout={cleanLayout}
            showNotif={showNotif}
            noHeaderLibrary={noHeaderLibrary}
            onBackButtonPress={onBackButtonPress}
          >
            <div>{this.props.children}</div>
            {!isMobile && !noFooter && <Footer />}
          </SideHeader>
        )}
        {!isLoading && (noHeaderRuntime || noHeader) && this.props.children}
        <ReduxToastr
          timeOut={8000}
          newestOnTop={false}
          preventDuplicates
          position="top-right"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          progressBar
          closeOnToastrClick
        />
        {/* {!isLoading && !isMobile && this.props.runtime.hasCoronaPage && this.props.runtime.activeCoronaSubs <= 0 && ( */}
        {!isLoading && this.props.runtime.hasCoronaPage && this.props.runtime.activeCoronaSubs <= 0 && (
          <CoronaPage
            updateCoronaPage={this.props.updateCoronaPage}
            hasCoronaPage={this.props.runtime.hasCoronaPage}
            isMobile={isMobile}
          />
        )}
        {
          isPhoneNumberEnabled && !isLoading && isShowAddIdentityModal && (
            <AddEmailPhoneModal
              onModalCancel={() => {
                this.setState({ isShowAddIdentityModal: false })
              }}
              type={identityModalType}
              isMobile={isMobile}
              handleOnVerification={this.handleOnVerification}
              isModalOpen={true}
            />
          )
        }

      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    token: state.user.token,
    runtime: { ...state.runtime },
    configParams: { ...state.configParams },
  }
}

const mapDispatchToProps = dispatch => ({
  updateCoronaPage: () => dispatch(setRuntimeVariable({ name: 'hasCoronaPage', value: false })),
  updateIsMobile: value => dispatch(setRuntimeVariable({ name: 'isMobile', value })),
  showSuccessAlert: message => dispatch(showSuccessAlert(message))
})

export default compose(withStyles(normalizeCss, styles), connect(mapStateToProps, mapDispatchToProps))(Layout)
